// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1I-pb","title":"Images45_title__1Hs-z","images":"Images45_images__TkXOj"};